// eslint-disable-next-line no-unused-vars
import { PerformanceChartStatsState } from '../types';
import '../../types';

/**
 * @param {PerformanceChartStatsState} draft - Draft state.
 * @param {object} payload - Action payload.
 * @param payload.seasonId
 * @param payload.roundStats
 * @param payload.index
 * @param payload.reset
 */
export const setPlayerTwoChartSeasonsStats = (
    draft,
    { seasonId, roundStats, reset }
) => {
    if (!reset) {
        draft.playerTwoData.season = {
            ...draft.playerTwoData.season,
            [seasonId]: [...roundStats]
        };
    } else {
        draft.playerTwoData.season = {};
        draft.playerTwoData.yearly = [];
    }
};
